<template>
  <div
    :class="[
      $style['notification'],
      { [$style[`notification--${type}`]]: type }
    ]">
    <svg-icon
      v-if="type === 'success'"
      :class="$style['svg-icon']"
      name="System/check-line" />
    <slot />
  </div>
</template>
<script setup lang="ts">
defineProps<{
  type?: string
}>()
</script>
<style lang="scss" module>
.notification {
  background-color: var(--grey-lighter);
  border-radius: var(--border-radius);
  display: flex;
  flex-direction: column;
  color: var(--grey-darkest);
  padding: calc(var(--spacing) * 2);
  line-height: var(--line-height);
  position: relative;
  text-align: left;

  .svg-icon {
    margin-right: var(--spacing);
    position: absolute;
    right: var(--spacing);
  }

  &--outline {
    background-color: transparent;
    border: 1px solid var(--grey-lighter);
  }

  &--error {
    background-color: var(--red-light);
    color: var(--red-dark);
  }

  &--success {
    background-color: var(--success-light);
    color: var(--black);
  }
}
</style>
